import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Calendar, MapPin, Clock, Users, CheckCircle, CreditCard, Award } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Badge } from '../components/ui/Badge';
import { Checkbox } from '../components/ui/Checkbox';
export function EventRegistrationPage() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const [agreed, setAgreed] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    organization: '',
    dietaryRestrictions: '',
    specialNeeds: ''
  });
  const event = {
    id: 1,
    title: 'Workshop React & Next.js Lanjutan',
    date: '15-16 Januari 2025',
    time: '09:00 - 17:00 WIB',
    location: 'Jakarta Tech Hub',
    type: 'offline',
    price: 'Rp 500.000',
    memberPrice: 'Rp 250.000',
    seats: 30,
    registered: 18,
    certificate: true
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!agreed) {
      alert('Anda harus menyetujui syarat dan ketentuan');
      return;
    }
    // Process registration
    navigate(`/payment/${id}`);
  };
  return <div className="min-h-screen bg-white" data-id="element-2639">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-2640">
        {/* Header */}
        <div className="mb-8" data-id="element-2641">
          <Button variant="ghost" onClick={() => navigate(`/events/${id}`)} className="mb-4" data-id="element-2642">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-2643" />
            Kembali ke Detail Acara
          </Button>
          <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-2644">
            Pendaftaran Acara
          </h1>
          <p className="text-neutral-600" data-id="element-2645">
            Lengkapi formulir untuk mendaftar ke acara ini
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-2646">
          {/* Event Summary */}
          <div className="lg:col-span-1" data-id="element-2647">
            <Card className="sticky top-8" data-id="element-2648">
              <CardHeader data-id="element-2649">
                <CardTitle className="text-base" data-id="element-2650">Ringkasan Acara</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4" data-id="element-2651">
                <div data-id="element-2652">
                  <h3 className="font-semibold text-neutral-900 mb-2" data-id="element-2653">
                    {event.title}
                  </h3>
                  {event.certificate && <Badge variant="success" className="text-xs" data-id="element-2654">
                      <Award className="w-3 h-3 mr-1" data-id="element-2655" />
                      Sertifikat
                    </Badge>}
                </div>

                <div className="space-y-3 text-sm" data-id="element-2656">
                  <div className="flex items-center gap-2 text-neutral-600" data-id="element-2657">
                    <Calendar className="w-4 h-4 text-atios-primary" data-id="element-2658" />
                    <span data-id="element-2659">{event.date}</span>
                  </div>
                  <div className="flex items-center gap-2 text-neutral-600" data-id="element-2660">
                    <Clock className="w-4 h-4 text-atios-primary" data-id="element-2661" />
                    <span data-id="element-2662">{event.time}</span>
                  </div>
                  <div className="flex items-center gap-2 text-neutral-600" data-id="element-2663">
                    <MapPin className="w-4 h-4 text-atios-primary" data-id="element-2664" />
                    <span data-id="element-2665">{event.location}</span>
                  </div>
                  <div className="flex items-center gap-2 text-neutral-600" data-id="element-2666">
                    <Users className="w-4 h-4 text-atios-primary" data-id="element-2667" />
                    <span data-id="element-2668">
                      {event.registered}/{event.seats} peserta
                    </span>
                  </div>
                </div>

                <div className="pt-4 border-t border-neutral-200" data-id="element-2669">
                  <div className="flex justify-between items-center mb-2" data-id="element-2670">
                    <span className="text-sm text-neutral-600" data-id="element-2671">
                      Harga Reguler
                    </span>
                    <span className="text-sm text-neutral-400 line-through" data-id="element-2672">
                      {event.price}
                    </span>
                  </div>
                  <div className="flex justify-between items-center" data-id="element-2673">
                    <span className="text-sm font-medium text-neutral-900" data-id="element-2674">
                      Harga Anggota
                    </span>
                    <span className="text-lg font-semibold text-atios-primary" data-id="element-2675">
                      {event.memberPrice}
                    </span>
                  </div>
                </div>

                <div className="bg-success-light border border-success/20 rounded-lg p-3" data-id="element-2676">
                  <div className="flex items-center gap-2 text-success text-sm" data-id="element-2677">
                    <CheckCircle className="w-4 h-4" data-id="element-2678" />
                    <span className="font-medium" data-id="element-2679">
                      Hemat Rp 250.000 sebagai anggota!
                    </span>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Registration Form */}
          <div className="lg:col-span-2" data-id="element-2680">
            <form onSubmit={handleSubmit} data-id="element-2681">
              <Card data-id="element-2682">
                <CardHeader data-id="element-2683">
                  <CardTitle data-id="element-2684">Data Pendaftar</CardTitle>
                </CardHeader>
                <CardContent className="space-y-6" data-id="element-2685">
                  <Input label="Nama Lengkap" required value={formData.fullName} onChange={e => setFormData({
                  ...formData,
                  fullName: e.target.value
                })} placeholder="John Doe" data-id="element-2686" />
                  <Input label="Email" type="email" required value={formData.email} onChange={e => setFormData({
                  ...formData,
                  email: e.target.value
                })} placeholder="john@example.com" helperText="Tiket dan sertifikat akan dikirim ke email ini" data-id="element-2687" />
                  <Input label="Nomor Telepon" type="tel" required value={formData.phone} onChange={e => setFormData({
                  ...formData,
                  phone: e.target.value
                })} placeholder="+62 812 3456 7890" data-id="element-2688" />
                  <Input label="Organisasi/Perusahaan (opsional)" value={formData.organization} onChange={e => setFormData({
                  ...formData,
                  organization: e.target.value
                })} placeholder="PT Teknologi Indonesia" data-id="element-2689" />

                  {event.type === 'offline' && <>
                      <Input label="Pantangan Makanan (opsional)" value={formData.dietaryRestrictions} onChange={e => setFormData({
                    ...formData,
                    dietaryRestrictions: e.target.value
                  })} placeholder="Vegetarian, alergi kacang, dll" data-id="element-2690" />
                      <Input label="Kebutuhan Khusus (opsional)" value={formData.specialNeeds} onChange={e => setFormData({
                    ...formData,
                    specialNeeds: e.target.value
                  })} placeholder="Kursi roda, dll" data-id="element-2691" />
                    </>}

                  <div className="pt-4 border-t border-neutral-200" data-id="element-2692">
                    <Checkbox label={<span className="text-sm text-neutral-700" data-id="element-2694">
                          Saya menyetujui{' '}
                          <a href="#" className="text-atios-primary hover:underline" data-id="element-2695">
                            syarat dan ketentuan
                          </a>{' '}
                          pendaftaran acara
                        </span>} checked={agreed} onChange={e => setAgreed(e.target.checked)} data-id="element-2693" />
                  </div>

                  <div className="flex gap-3 pt-4" data-id="element-2696">
                    <Button type="button" variant="secondary" onClick={() => navigate(`/events/${id}`)} className="flex-1" data-id="element-2697">
                      Batal
                    </Button>
                    <Button type="submit" className="flex-1" data-id="element-2698">
                      <CreditCard className="w-4 h-4 mr-2" data-id="element-2699" />
                      Lanjut ke Pembayaran
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </form>
          </div>
        </div>
      </div>
    </div>;
}